import { INTAKE_ROOT_PATH, isPayerConnectionsPath, resolveIntakePageKey } from '../../routing';

import type { IntakeJourneyStage } from './IntakeJourneyShell';

export function resolveJourneyStage(
  pathname: string,
  search: string,
  payerEnabled: boolean,
  defaultStage: 'agreements' | 'intake' = 'agreements',
): IntakeJourneyStage {
  const params = new URLSearchParams(search);
  const stage = params.get('intakeStage');
  if (
    stage === 'agreements' ||
    stage === 'intake' ||
    stage === 'verification' ||
    stage === 'import'
  ) {
    return stage;
  }
  if (stage === 'payers') return payerEnabled ? 'payers' : 'intake';
  if (isPayerConnectionsPath(pathname) || params.get('intakeSection') === 'payer-connections') {
    return payerEnabled ? 'payers' : 'intake';
  }
  return resolveIntakePageKey(pathname) || params.has('intakeStep') ? 'intake' : defaultStage;
}

/** Keep the nested intake step and unrelated query parameters through every stage roundtrip. */
export function journeyStageLocation(pathname: string, search: string, stage: IntakeJourneyStage) {
  const params = new URLSearchParams(search);
  params.set('intakeStage', stage);
  params.delete('intakeSection');
  return {
    pathname: isPayerConnectionsPath(pathname) && stage !== 'payers' ? INTAKE_ROOT_PATH : pathname,
    search: params.toString(),
  };
}
